
import { countryMapping } from './CountryMapping';
import { regionMapping } from './RegionMapping';
import { cityMapping } from './CityMapping';

export const locationMapping = {
  countries: countryMapping,
  regions: regionMapping,
  cities: cityMapping
};

export interface DetectedLocation {
  type: 'country' | 'region' | 'city';
  info: any;
}

export const detectLocation = (searchTerms: string[]): DetectedLocation | null => {
  // Check for cities first (most specific)
  for (const [term, info] of Object.entries(locationMapping.cities)) {
    if (searchTerms.some(searchTerm => searchTerm.includes(term) || term.includes(searchTerm))) {
      console.log('Detected city:', term, info);
      return { type: 'city', info };
    }
  }
  
  // Then check for regions
  for (const [term, info] of Object.entries(locationMapping.regions)) {
    if (searchTerms.some(searchTerm => searchTerm.includes(term) || term.includes(searchTerm))) {
      console.log('Detected region:', term, info);
      return { type: 'region', info };
    }
  }
  
  // Finally check for countries
  for (const [term, country] of Object.entries(locationMapping.countries)) {
    if (searchTerms.some(searchTerm => searchTerm.includes(term) || term.includes(searchTerm))) {
      console.log('Detected country:', term, country);
      return { type: 'country', info: { country } };
    }
  }
  
  return null;
};
